'use client';

const SESSION_KEY = 'nf_current_user';

export interface SessionUser {
  id: string;
  nome: string;
  email: string;
  cargo: 'Administrador' | 'Gerente' | 'Funcionário';
  permissoes: string[];
  empresaId: string;
  empresaNome: string;
  ativo: boolean;
}

export const getSession = (): SessionUser | null => {
  if (typeof window === 'undefined') return null;
  try {
    const raw = localStorage.getItem(SESSION_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};
